import { component } from 'picoapp';
import customScrollbar from 'utils/custom-scrollbar';

export default component(async (node) => {
  const instafeedContainer = node.querySelector('.instafeed-shopify');

  const scrollElement:HTMLElement = node.querySelector('[hide-scrollbar]');
  const scrollbar:HTMLElement = node.querySelector('.scrollbar__slider--wrapper');
  const scrollIndicator:HTMLElement = node.querySelector('.scrollbar__slider--indicator');
  customScrollbar(scrollElement, scrollbar, scrollIndicator);

  const observer = new MutationObserver(() => {
    const images = node.querySelectorAll('.instafeed-container');
    if (images.length > 0) {
      images.forEach((image) => {
        image.removeAttribute('style');
      });
      observer.disconnect();
    }
  });

  observer.observe(instafeedContainer, { childList: true, subtree: true });
});
